"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var UnsupportedProperties = /** @class */ (function (_super) {
    tslib_1.__extends(UnsupportedProperties, _super);
    function UnsupportedProperties() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UnsupportedProperties.prototype.render = function () {
        return (react_1.default.createElement("div", { className: this.getClassNames() },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "properties.unsupported" })));
    };
    UnsupportedProperties.prototype.getClassNames = function () {
        return classnames_1.default("adi-unsupported-configuration", "s-properties-unsupported");
    };
    return UnsupportedProperties;
}(react_1.default.Component));
exports.default = UnsupportedProperties;
//# sourceMappingURL=UnsupportedProperties.js.map